import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import actions from '@/redux/action';
import sentGAEvent from '@/ga';
import Utils from '@/utils';
import { request } from '@/api/request';
import AudioExtractWorkFunction from './children/audioExtractorWorkFunction/AudioExtractorWorkFunction';
import AudioExtractorCompleteFunction from './children/audioExtractorCompleteFunction/AudioExtractorCompleteFunction';
import '@/assets/audioExtractor.less';
import moment from 'moment';
import { api_config } from '@/constants/api';
import indexDB from '../../../utils/indexDB';

class AudioExtractorWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioExtractorFileAfter: null,
      submitting: false,
    };
    this.cancelExtract = false;
  }

  componentDidMount() {
    this.initFile();
  }

  initFile = async () => {
    if (indexDB) {
      let res = await indexDB.read();
      if (!res) {
        let uploadDom = document.getElementById('UploadProps');
        uploadDom.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      }
    }
  };

  onChangeAudioExtractorFile = async (obj) => {
    this.props.onAudioExtractorFileChange(obj);
    if (indexDB != null) {
      if (obj != null) {
        indexDB.saveOrUpdate({
          fileId: 'audioExtractorFile',
          file: obj,
        });
      }
    }
  };

  deleteAudioExtractFile = async () => {
    sentGAEvent({
      category: 'vc_referral',
      action: 'audio_extractor_add_files_delete',
    });
    this.props.onAudioExtractorFileChange(null);

    if (indexDB != null) {
      let delRes = await indexDB.remove();
      console.log('delRes', delRes);
    }
  };

  handleSubmitFail = (audioExtractorFileAfter, error) => {
    console.log(error);
    if (error !== 'cancel' || !error) {
      console.log('进来这里');
      audioExtractorFileAfter.status = 'failed';
      this.setState({ audioExtractorFileAfter });
      if (Utils.getSystemType() != 'other') {
        this.props.hideLink(true);
        this.props.advertiseConfig({
          isShowHeader: true,
          headerObj: 'failed',
          titleIndex: 4,
          imgIndex: 3,
          source: 'failed',
        });
        this.props.openAdvertiseDialog(true);
        sentGAEvent({
          category: 'vc_referral',
          action: 'AudioExtractor_ExtractFailedShow',
        });
      }
    }
    this.props.onProcessStepChange(0);
    this.props.onProcessPercentChange(0);
    this.props.onUploadPercentChange(0);
    this.props.onUploadXHRChange(null);
    this.setState({ submitting: false });
  };

  handleSubmitAgain = () => {
    this.props.advertiseConfig({
      isShowBtn: false,
      isShowHeader: true,
      headerObj: 'extract',
      titleIndex: 3,
      imgIndex: 2,
      source: 'extract',
    });
    this.props.openAdvertiseDialog(true);
    this.setState({ audioExtractorFileAfter: null }, () =>
      this.handleSubmit(this.state.format)
    );
  };

  handleSubmit = async (format) => {
    let startTime = new Date().getTime();
    let size = this.props.audioExtractorFile.fileObj
      ? this.props.audioExtractorFile.fileObj.size
      : this.props.audioExtractorFile.size;
    sentGAEvent({
      category: 'audio_extractor_output',
      action: 'audio_extractor_output',
      label: '1_' + format + '_' + (size / 1024).toFixed(2) + 'kb',
    });
    this.cancelExtract = false;
    this.setState({ format, submitting: true });
    let audioExtractorFileAfter = { ...this.props.audioExtractorFile };
    if (!audioExtractorFileAfter.videofileurl) {
      this.props.onProcessStepChange(3);
      audioExtractorFileAfter = await this.handleUploadAndExtract(
        audioExtractorFileAfter,
        format
      );
    } else {
      this.props.onProcessStepChange(1);
      audioExtractorFileAfter = await this.handleExtract(
        audioExtractorFileAfter,
        audioExtractorFileAfter.videofileurl,
        format
      );
    }
    sentGAEvent({
      category: 'audio_extractor_output',
      action: 'audio_extracting_time',
      label:
        moment(new Date().getTime()).diff(moment(startTime), 'seconds') + 's',
    });
    if (!audioExtractorFileAfter) {
      return false;
    }
    sentGAEvent({
      category: 'audio_extractor_output',
      action: 'audio_extractor_output_success',
      label:
        '1_' +
        format +
        '_' +
        (audioExtractorFileAfter.size / 1024).toFixed(2) +
        'kb',
    });
    this.props.onProcessStepChange(0);
    this.props.onProcessPercentChange(0);
    this.props.onUploadPercentChange(0);
    this.setState({ submitting: false });
    this.setState({ audioExtractorFileAfter });
  };

  handleUploadAndExtract = async (audioExtractorFileAfter, format) => {
    let fileResponse;
    try {
      fileResponse = await this.requestUploadVideoFile(
        audioExtractorFileAfter.fileObj
      );
    } catch (error) {
      this.handleSubmitFail(audioExtractorFileAfter, error);
      if (error !== 'cancel') {
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label: error + '_none_none_' + this.props.tokenId + '_none_none',
        });
      }
      return false;
    }
    if (this.cancelExtract) {
      this.handleSubmitFail(audioExtractorFileAfter, 'cancel');
      return false;
    }
    if (fileResponse.code === 200) {
      if (fileResponse.data.result.number) {
        const fileResponseNumber = fileResponse.data.result.number;
        const fileResponseUrl = fileResponse.data.response_file[0];
        try {
          await Utils.getProgress(fileResponseNumber, false);
          sentGAEvent({
            category: 'UploadSuccess',
            action: '26AE_UploadSuccess',
            label: 'Null',
          });
        } catch (error) {
          if (error !== 'cancel') {
            sentGAEvent({
              category: 'Upload',
              action: 'LocalSerFail',
              label: 'uploadAudio' + '_200_200_' + error,
            });
          }
          this.handleSubmitFail(audioExtractorFileAfter, error);
          return false;
        }
        audioExtractorFileAfter = await this.handleExtract(
          audioExtractorFileAfter,
          fileResponseUrl,
          format
        );
      }
    } else {
      this.handleSubmitFail(audioExtractorFileAfter);
      sentGAEvent({
        category: 'Upload',
        action: 'LocalSerFail',
        label:
          'uploadAudio' +
          '_200_' +
          fileResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          fileResponse.msg,
      });
      return false;
    }
    return audioExtractorFileAfter;
  };

  handleExtract = async (audioExtractorFileAfter, fileUrl, format) => {
    let compressResponse;
    try {
      compressResponse = await this.requstExtractAudio(format, fileUrl);
    } catch (error) {
      if (error !== 'cancel') {
        sentGAEvent({
          category: 'audio_extractor_output',
          action: 'audio_extractor_output_failed',
          label: error + '_none_none_' + this.props.tokenId + '_none_none',
        });
        sentGAEvent({
          category: 'audio_extractor_output',
          action: 'audio_extractor_output_failed',
          label:
            '1_' +
            format +
            '_' +
            (this.props.audioExtractorFile.fileObj.size / 1024).toFixed(2) +
            'kb',
        });
      }
      this.handleSubmitFail(audioExtractorFileAfter, error);
      return false;
    }
    if (this.cancelExtract) {
      this.handleSubmitFail(audioExtractorFileAfter, 'cancel');
      return false;
    }
    if (compressResponse.code === 200) {
      sentGAEvent({
        category: 'ProcessStart',
        action: '26AE_ProcessStart',
        label: 'Null',
      });
      const compressResponseNumber = compressResponse.data.result.number;
      let extractProgressResponse;
      try {
        extractProgressResponse = await Utils.getProgress(
          compressResponseNumber,
          false
        );
      } catch (error) {
        if (error !== 'cancel') {
          sentGAEvent({
            category: 'audio_extractor_output',
            action: 'audio_extractor_output_failed',
            label: 'extractAudio' + '_200_200_' + error,
          });
          sentGAEvent({
            category: 'audio_extractor_output',
            action: 'audio_extractor_output_failed',
            label:
              '1_' +
              format +
              '_' +
              (this.props.audioExtractorFile.fileObj.size / 1024).toFixed(2) +
              'kb',
          });
        }
        this.handleSubmitFail(audioExtractorFileAfter, error);
        return false;
      }

      audioExtractorFileAfter.status = 'success';
      this.props.hideLink(true);
      this.props.advertiseConfig({
        isShowBtn: false,
        isShowHeader: true,
        headerObj: 'success', //是否显示对话框头部,以及展示类型
        titleIndex: 0,
        imgIndex: 0,
        source: '',
      });
      sentGAEvent({
        category: 'ProcessSuccess',
        action: '26AE_ProcessSuccess',
        label: 'Null',
      });
      this.props.openAdvertiseDialog(false);
      audioExtractorFileAfter.size = extractProgressResponse.info[0].size;
      audioExtractorFileAfter.format = format;
      audioExtractorFileAfter.downloadurl = extractProgressResponse.info[0].url;
      audioExtractorFileAfter.name = audioExtractorFileAfter.name.replace(
        /\.[^.]+$/,
        `.${format}`
      );
    } else {
      if (compressResponse.code === 402102) {
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: 'videoEditorTimesMoreThanLimit',
          trigger: '6TrialOver',
        });
        sentGAEvent({
          category: 'UpgradePrompShow',
          action: '26AE_UpgradePrompShow',
        });
        this.handleSubmitFail(audioExtractorFileAfter, 'cancel');
        this.props.openAdvertiseDialog(false);
        return null;
      } else {
        this.handleSubmitFail(audioExtractorFileAfter);
        this.props.openAdvertiseDialog(false);
      }
      sentGAEvent({
        category: 'audio_extractor_output',
        action: 'audio_extractor_output_failed',
        label:
          'extractAudio' +
          '_200_' +
          compressResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          compressResponse.msg,
      });
      sentGAEvent({
        category: 'audio_extractor_output',
        action: 'audio_extractor_output_failed',
        label:
          '1_' +
          format +
          '_' +
          (this.props.audioExtractorFile.fileObj.size / 1024).toFixed(2) +
          'kb',
      });
    }
    return audioExtractorFileAfter;
  };

  requstExtractAudio = (format, url) => {
    const formData = new FormData();
    formData.append('output_format', format);
    formData.append('file_url', url);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`extractAudio`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  requestUploadVideoFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    sentGAEvent({
      category: 'UploadStart',
      action: '26AE_UploadStart',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadVideo`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.uploadPercent < 100) {
            this.props.onUploadPercentChange(percent);
          } else {
            this.props.onUploadPercentChange(
              percent +
                (this.props.uploadPercent - (this.props.uploadPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadVideo_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  render() {
    return (
      <div className='workplace'>
        {!this.state.audioExtractorFileAfter ? (
          <AudioExtractWorkFunction
            audioExtractorFile={this.props.audioExtractorFile}
            onChangeAudioExtractorFile={this.onChangeAudioExtractorFile}
            deleteAudioExtractFile={this.deleteAudioExtractFile}
            handleSubmit={this.handleSubmit}
            advertiseConfig={this.props.advertiseConfig}
            openAdvertiseDialog={this.props.openAdvertiseDialog}
            submitting={this.state.submitting}
            cancelProcessCallBack={() => {
              this.setState({
                submitting: false,
                audioExtractorFileAfter: null,
              });
              this.cancelExtract = true;
              console.log('取消提取');
            }}
          />
        ) : (
          <AudioExtractorCompleteFunction
            openAdvertiseDialog={this.props.openAdvertiseDialog}
            downloadPercent={this.props.downloadPercent}
            advertiseConfig={this.props.advertiseConfig}
            onUploadXHRChange={this.props.onUploadXHRChange}
            audioExtractorFileAfter={this.state.audioExtractorFileAfter}
            handleSubmitAgain={this.handleSubmitAgain}
          />
        )}
      </div>
    );
  }
}
const mapStateToPropos = (state) => ({
  audioExtractorFile: state.work.audioExtractorFile,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onAudioExtractorFileChange: (audioExtractorFile) =>
    dispatch(actions.onAudioExtractorFileChange(audioExtractorFile)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
  advertiseConfig: (advertiseConfig) =>
    dispatch(actions.advertiseConfig(advertiseConfig)),
  openAdvertiseDialog: (visible) =>
    dispatch(actions.openAdvertiseDialog(visible)),
  downloadPercent: (percent) => dispatch(actions.downloadPercent(percent)),
  hideLink: (isHide) => dispatch(actions.hideLink(isHide)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['audioExtractor'])(AudioExtractorWork));
